module.exports = __webpack_public_path__ + "static/media/4_MACDONALDS.ddd3c913.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/realisations/projet_mcdonalds/4_MACDONALDS.jpg
// module id = 1165
// module chunks = 37